<template>
    <PopupRouterView :showLeftIcon="true" label="Delivery Instruction Delivery Card Input"
        okTitle="Save"
        cancelTitle="Cancel"
        entityName="deliveryinstructiondeliverycard"
        :documentId="mainRecordId"
        @saveMethod="saveAction"
        @hideMethod="onHidden"
        ref="deliveryInstructionDeliveryCardInput">


        <b-card header="Delivery Card" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-label label-cols-lg="12" size="sm" type="generatednumber" label="Delivery Card Number" :model="model.deliveryCardNumber" />
						<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" label-cols-lg="12" label="Part" id="fieldset-part" size="sm" :model.sync="model.partId" :isRequired="true" :state="validateState('partId')" :errorMessage="getErrorMessage(errorMessage.partId, 'partId')"   :selected="model.part != null ? model.part.partNumber : ''" @input="getParts"  :isUpdatable ="null" :isSelectMethodExists="true" @onSelectMethod="setSelectedPart" />
						<app-input-textbox id="fieldset-dc-qty" label-cols-lg="12"  label="DC Qty" label-for="input-dc-qty" size="sm" :model.sync="model.dcQty" :isRequired="true" :state="validateState('dcQty')" :errorMessage="getErrorMessage(errorMessage.dcQty, 'dcQty')"   :isUpdatable ="null"/>
						<app-input-combobox-autocomplete :options="deliveryInstructionDetails" optionsLabel="part" optionsKey="id" label-cols-lg="12" label="DI Detail" id="fieldset-delivery-instruction-detail" size="sm" :model.sync="model.deliveryInstructionDetailId" :isRequired="true" :state="validateState('deliveryInstructionDetailId')" :errorMessage="getErrorMessage(errorMessage.deliveryInstructionDetailId, 'deliveryInstructionDetailId')"   :selected="model.deliveryInstructionDetail != null ? model.deliveryInstructionDetail.part : ''" @input="getDeliveryInstructionDetails"  :isUpdatable ="null" :isSelectMethodExists="true" @onSelectMethod="setSelectedDeliveryInstructionDetail" />
						<app-input-datetimepicker id="fieldset-delivery-date" label-cols-lg="12"  label="Delivery Date" size="sm" :model.sync="model.deliveryDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"  :isUpdatable ="null"/>
						<app-input-textbox id="fieldset-sequence" label-cols-lg="12"  label="Sequence" label-for="input-sequence" size="sm" type="number" :model.sync="model.sequence"   :isUpdatable ="null"/>
						<app-input-textbox id="fieldset-total-delivery-card" label-cols-lg="12"  label="Total Delivery Card" label-for="input-total-delivery-card" size="sm" :model.sync="model.totalDeliveryCard"   :isUpdatable ="null"/>
						<app-input-checkbox id="fieldset-is-is-fullfiled" label-cols-lg="12" label="Is Fullfiled" label-for="input-is-is-fullfiled" size="sm" :model.sync="model.isFullfiled" :isUpdatable ="null"checkedValue="Yes" uncheckedValue="No"  />
						<app-input-combobox-autocomplete :options="controlCardStatuss" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Control Card Status" id="fieldset-control-card-status" size="sm" :model.sync="model.controlCardStatusId"   :selected="model.controlCardStatus != null ? model.controlCardStatus.name : ''" @input="getControlCardStatuss"  :isUpdatable ="null" :isSelectMethodExists="true" @onSelectMethod="setSelectedControlCardStatus" />
						<app-input-checkbox id="fieldset-is-is-loading" label-cols-lg="12" label="Is Loading" label-for="input-is-is-loading" size="sm" :model.sync="model.isLoading" :isUpdatable ="null"checkedValue="Yes" uncheckedValue="No"  />
						<app-input-textbox id="fieldset-delivery-qty" label-cols-lg="12"  label="Delivery Qty" label-for="input-delivery-qty" size="sm" :model.sync="model.deliveryQty"   :isUpdatable ="null"/>
					</b-col>
					<b-col cols="12" lg="6">
				</b-col>

            </b-row>
        </b-card>



        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterView>
</template><script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import DeliveryInstructionDeliveryCard from '@/models/DeliveryInstructionDeliveryCard/DeliveryInstructionDeliveryCard';
import DeliveryInstructionDeliveryCardList from '@/models/DeliveryInstructionDeliveryCard/DeliveryInstructionDeliveryCardList';
import DeliveryInstructionDeliveryCardFilter from '@/filters/DeliveryInstructionDeliveryCard/DeliveryInstructionDeliveryCardFilter';

import AppLabel from '@/components/AppLabel';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import DeliveryInstructionDetail from '@/models/DeliveryInstruction/DeliveryInstructionDetail';
import DeliveryInstructionDetailFilter from '@/filters/DeliveryInstruction/DeliveryInstructionDetailFilter';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
import AppInputCheckbox from '@/components/AppInputCheckbox';
import ControlCardStatus from '@/models/ControlCardStatus/ControlCardStatus';
import ControlCardStatusFilter from '@/filters/ControlCardStatus/ControlCardStatusFilter';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppLabel,
		AppInputComboboxAutocomplete,
		AppInputTextbox,
		AppInputDatetimepicker,
		AppInputDatetimepickerRange,
		AppInputCheckbox,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
			partId: {required},
			dcQty: {required},
			deliveryInstructionDetailId: {required},
		},
	},
	data() {
		return {
			errorMessage : {
				partId: { required : "Part is Required."},
				dcQty: { required : "DC Qty is Required."},
				deliveryInstructionDetailId: { required : "DI Detail is Required."},
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterDeliveryInstructionDeliveryCard : null,
			currentDeliveryInstructionDeliveryCardPage : 1,
			deliveryInstructionDeliveryCardPageSize: 10,
			sortByDeliveryInstructionDeliveryCard: '',
			sortDescDeliveryInstructionDeliveryCard: '',
			parts: [],
			parts: [],
			isPartComboLoading: false,
			deliveryInstructionDetails: [],
			deliveryInstructionDetails: [],
			isDeliveryInstructionDetailComboLoading: false,
			controlCardStatuss: [],
			controlCardStatuss: [],
			isControlCardStatusComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isPartComboLoading: false,
			isDeliveryInstructionDetailComboLoading: false,
			isControlCardStatusComboLoading: false,
		}
	},
	methods : {
		showPopupWithMessage : async function(message) {
			const msg = this.$createElement;
			let msgNode = '';
			let result = false;
			msgNode = msg('div', { domProps: { innerHTML: '<p>'+message+'</p>' } })
			await this.$bvModal.msgBoxConfirm([msgNode], {
				title: 'Alert',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				cancelVariant: 'secondary',
				okTitle: 'Yes',
				cancelTitle: 'No',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(e=>{
				if(e){
					result = true;
				}
			});
			return result;
		},
		getDeliveryInstructionDeliveryCard : async function(id) {
			this.isBusy = true;
			DeliveryInstructionDeliveryCard.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadDeliveryInstructionDeliveryCard = true;
			this.filterDeliveryInstructionDeliveryCard.id = this.modelId;
			DeliveryInstructionDeliveryCard.downloadDataDetail(this, this.filterDeliveryInstructionDeliveryCard).then(result => {
				this.isDownloadDeliveryInstructionDeliveryCard = false;
			}).catch(error => { this.isDownloadDeliveryInstructionDeliveryCard = false; })
		},
		getDeliveryInstructionDeliveryCards : async function(input) {
			let filter = new DeliveryInstructionDeliveryCardFilter();
			if (input != undefined) {
				filter.DeliveryCardNumber = input;
			}
			this.isDeliveryInstructionDeliveryCardComboLoading = true;
			DeliveryInstructionDeliveryCard.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.deliveryInstructionDeliveryCards = result.data
				}
				this.isDeliveryInstructionDeliveryCardComboLoading = false;
			})
			.catch(error => {});
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedPart(item) {
			if(item == undefined || item == null) {
				this.model.partId = null;
				this.model.part = null;
			} else {
				this.model.partId = item.id;
				this.model.part = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getDeliveryInstructionDetails : async function(input) {
			let filter = new DeliveryInstructionDetailFilter();
			if (input != undefined) {
				filter.part = input;
			}
			DeliveryInstructionDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.deliveryInstructionDetails = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedDeliveryInstructionDetail(item) {
			if(item == undefined || item == null) {
				this.model.deliveryInstructionDetailId = null;
				this.model.deliveryInstructionDetail = null;
			} else {
				this.model.deliveryInstructionDetailId = item.id;
				this.model.deliveryInstructionDetail = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getControlCardStatuss : async function(input) {
			let filter = new ControlCardStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ControlCardStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCardStatuss = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedControlCardStatus(item) {
			if(item == undefined || item == null) {
				this.model.controlCardStatusId = null;
				this.model.controlCardStatus = null;
			} else {
				this.model.controlCardStatusId = item.id;
				this.model.controlCardStatus = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.deliveryInstructionDeliveryCardInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				let promises = Array();

				Promise.all(promises).then((results) => {
					if (id != '' && id != null && id != undefined) {
						DeliveryInstructionDeliveryCard.updateData(this, model, id).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'deliveryinstructiondeliverycardindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						DeliveryInstructionDeliveryCard.insertData(this, model).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'deliveryinstructiondeliverycardindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					}
				});
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					DeliveryInstructionDeliveryCard.updateData(this, model, id)
					.catch((error) => {
						this.getDeliveryInstructionDeliveryCard(id);
					});
				}
			});
		},
		onHidden() {
			this.getDeliveryInstructionDeliveryCards();
		},
		resetModal(modalType) {
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
	},
	beforeMount() {
		this.filterDeliveryInstructionDeliveryCard = new DeliveryInstructionDeliveryCardFilter();
		//this.getParts();
		//this.getDeliveryInstructionDetails();
		//this.getControlCardStatuss();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getDeliveryInstructionDeliveryCard(id);
			} else {
				this.modelId = id;
				this.getDeliveryInstructionDeliveryCard(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				return true;
			}
		}
	},
	watch : {
	},
}
</script>
